{
  "profile": "View Profile",
  "selected": "Selected",
  "log_out": "Log out",
  "terms_services": "Terms of service",
  "agencies": "Agencies",
  "all-agencies": "All agencies",
  "chargeSettings": "Charge Settings",
  "aiUsage": "AI Usage",
  "aiConfig": {
    "title": "AI Options"
  }
}
